var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNewWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_3_1",
    "data-name": "Component 3 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.049,
    height: 14,
    viewBox: "0 0 14.049 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1",
    "data-name": "Fill 1",
    d: "M11.116,5.077A.925.925,0,0,0,10.189,6v4.154H1.853V1.846H6.021A.923.923,0,1,0,6.021,0H.926A.925.925,0,0,0,0,.923V11.077A.925.925,0,0,0,.926,12H11.116a.925.925,0,0,0,.926-.923V6a.925.925,0,0,0-.926-.923",
    transform: "translate(0 2)",
    fill: "#3074ff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Fill_4",
    "data-name": "Fill 4",
    d: "M7.119,0H3.03a.906.906,0,1,0,0,1.811h1.9L.266,6.454A.907.907,0,0,0,1.551,7.735L6.21,3.092h0V4.981a.909.909,0,0,0,1.818,0V.906A.907.907,0,0,0,7.119,0",
    transform: "translate(6.021)",
    fill: "#3074ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNewWindow);
export default __webpack_public_path__ + "static/media/icon-new-window.50e200f3f6b460178671f9e032fb5bba.svg";
export { ForwardRef as ReactComponent };